export const formValidationMessages = {
    en: {
        firstname_error: "First Name must not include symbols or numbers.",
        lastname_error: "Last Name must not include symbols or numbers.",
        phone_error: "Phone number is invalid. Must be 8 to 20 digits.",
        thank_you_text: "Thank you for reaching out to us. We will be in touch!",
        form_submission_error: "Form submission error. Please try again.",
        personal_email_error: "Enter valid business email address",
    },
    de: {
        firstname_error: "Der Vorname darf keine Symbole oder Zahlen enthalten.",
        lastname_error: "Der Nachname darf keine Symbole oder Zahlen enthalten.",
        phone_error: "Die Telefonnummer ist ungültig. Muss 8 bis 20 Ziffern haben.",
        thank_you_text: "Vielen Dank, dass Sie uns kontaktiert haben. Wir werden uns in Kürze bei Ihnen melden!",
        form_submission_error: "Fehler beim Senden des Formulars. Bitte versuche es erneut.",
        personal_email_error: "Bitte die geschäftliche E-Mail-Adresse eingeben.",
    },
    es: {
        firstname_error: "El nombre no debe incluir símbolos ni números.",
        lastname_error: "El apellido no debe incluir símbolos ni números.",
        phone_error: "El número de teléfono es inválido. Debe tener de 8 a 20 dígitos.",
        thank_you_text: "Gracias por contactarnos. ¡Nos pondremos en contacto!",
        form_submission_error: "Error al enviar el formulario. Por favor, inténtelo de nuevo.",
        personal_email_error: "Indique una dirección de correo electrónico profesional válida",
    },
    fr: {
        firstname_error: "Le prénom ne doit pas inclure de symboles ou de numéros.",
        lastname_error: "Le nom de famille ne doit pas inclure de symboles ou de numéros.",
        phone_error: "Le numéro de téléphone n'est pas valide. Doit être de 8 à 20 chiffres.",
        thank_you_text: "Merci de nous avoir contactés. Nous reviendrons vers vous bientôt !",
        form_submission_error: "Erreur de soumission du formulaire. Veuillez réessayer.",
        personal_email_error: "Saisissez une adresse électronique professionnelle valide",
    },
    it: {
        firstname_error: "Il nome non deve includere simboli o numeri.",
        lastname_error: "Cognome non deve includere simboli o numeri.",
        phone_error: "Il numero di telefono non è valido. Deve essere di 8-20 cifre.",
        thank_you_text: "Grazie per il tuo interesse. Restiamo in contatto!",
        form_submission_error: "Errore di invio del modulo. Per favore riprova.",
        personal_email_error: "Inserisci un indirizzo email aziendale valido",
    },
    pt: {
        firstname_error: "O nome não deve incluir símbolos ou números.",
        lastname_error: "O sobrenome não deve incluir símbolos ou números.",
        phone_error: "O número de telefone é inválido. Deve ter de 8 a 20 dígitos.",
        thank_you_text: "Obrigado por entrar em contato conosco. Entraremos em contato!",
        form_submission_error: "Erro no envio do formulário. Por favor, tente novamente.",
        personal_email_error: "Insira um endereço de e-mail profissional válido",
    },
    ja: {
        firstname_error: "名に記号または数字を含めることはできません。",
        lastname_error: "姓には、記号または数字を含めることはできません。",
        phone_error: "電話番号が無効です。8 桁から 20 桁でなければなりません。",
        thank_you_text: "お問い合わせいただきありがとうございます。後ほど弊社よりご連絡差し上げます。!",
        form_submission_error: "フォーム送信エラー。もう一度試してください。",
        personal_email_error: "ビジネス用のメールアドレスを入力してください",
    },
};
